import { useState, useCallback } from 'react';

export function useExpandedRows<T>() {
  const [expandedRowIds, setExpandedRowIds] = useState<T[]>([]);

  const handleExpand = useCallback((id: T) => {
    setExpandedRowIds((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  }, []);

  return { expandedRowIds, handleExpand };
}
